<template>
  <div class="page">

    <div class="balance-header flex-box">
      <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
      <div class="title">浪花余额</div>
    </div>
    <div class="balance-amount">{{sprayBalance}}</div>
    <div class="usage-hint">浪花用途：申请认识TA</div>
    <!-- <div class="usage-hint">浪花用途：申请认识TA；解锁喜欢你的人；解锁访客</div> -->

    <div class="btn-next" @click="openPackagePopup">充值</div>
    <!-- <div class="free-spray"><text class="text">免费获得</text></div> -->

    <van-popup v-model="showPackagePopup" class="package-popup"   position="bottom"
    @click-overlay="closePackagePopup"
    custom-style="min-height: 40%;border-top-left-radius:20px;border-top-right-radius:20px;padding:30px 20px;">
      <div class="balance">浪花余额：{{sprayBalance}}</div>
      <div class="packages flex-box">

        <div class="package" :style="{'border': getPackageBorder(pickedAmount, 20), 'background':getPackageBackgroundColor(pickedAmount, 20)}" @click="pickPackage(20)" v-if="twenty_pay_times < 5">
          <div class="package-header flex-box"><div class="hint">限购5次</div></div>
          <div class="icon-and-amount flex-box">
            <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
            <div class="amount">20</div>
          </div>
          <div class="price">20元</div>
        </div>

        <div class="package" :style="{'border': getPackageBorder(pickedAmount, 100), 'background':getPackageBackgroundColor(pickedAmount, 100)}" @click="pickPackage(100)">
          <div class="package-header flex-box"><div class="hint">限时96折</div></div>
          <div class="icon-and-amount flex-box">
            <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
            <div class="amount">100</div>
          </div>
          <div class="price">96元</div>
        </div>

        <div class="package row-end" :style="{'border': getPackageBorder(pickedAmount, 200), 'background':getPackageBackgroundColor(pickedAmount, 200)}" @click="pickPackage(200)">
          <div class="package-header flex-box"><div class="hint">限时9折</div></div>
          <div class="icon-and-amount flex-box">
            <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
            <div class="amount">200</div>
          </div>
          <div class="price">180元</div>
        </div>

        <div class="package" :style="{'border': getPackageBorder(pickedAmount, 500), 'background':getPackageBackgroundColor(pickedAmount, 500)}" @click="pickPackage(500)">
          <div class="package-header flex-box"><div class="hint">限时8折</div></div>
          <div class="icon-and-amount flex-box">
            <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
            <div class="amount">500</div>
          </div>
          <div class="price">399元</div>
        </div>

        <div class="package" :style="{'border': getPackageBorder(pickedAmount, 1000), 'background':getPackageBackgroundColor(pickedAmount, 1000)}" @click="pickPackage(1000)">
          <div class="package-header flex-box"><div class="hint">限时75折</div></div>
          <div class="icon-and-amount flex-box">
            <img class="icon-spray" src="https://static.huiyiji520.com/icon-spray-1686720287.png">
            <div class="amount">1000</div>
          </div>
          <div class="price">750元</div>
        </div>

      </div>
      <div class="btn-pay-instant" @click="sumitPay">立即充值</div>
    </van-popup>

  </div>
</template>


<script>
import { Dialog, Toast, Popup, Checkbox, Loading, Icon, Field } from 'vant'

export default{
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Checkbox.name]: Checkbox,
    [Loading.name]: Loading,
    [Icon.name]: Icon,
    [Field.name]: Field
  },
  data(){
    return {
      showPackagePopup: false,
      pickedAmount: 100,
      sprayBalance: 0,
      twenty_pay_times: 0
    }
  },
  methods: {
    handleRouter(path){
      this.$router.push(path)
    },
    openPackagePopup(){
      this.showPackagePopup = true
    },
    closePackagePopup(){
      this.showPackagePopup = false
    },
    pickPackage(amount){
      this.pickedAmount = amount
    },
    getPackageBorder(pickedAmount, amount){
      if(pickedAmount == amount){
        return '4rpx solid #FF802C';
      }else{
        return "none"
      }
    },
    getPackageBackgroundColor(pickedAmount, amount){
      if(pickedAmount == amount){
        return "#FFF2F0"
      }else{
        return "#F7F7F7"
      }
    },
    getSprayBalance(){
      let mini_openid = this.$route.params.mini_openid
      this.$api.get('/tuodan/guest/get_spraycoin_balance_by_mini_openid', {mini_openid: mini_openid}, res => {
        if(res.code == 200){
          this.sprayBalance = res.spray_balance
          this.twenty_pay_times = res.twenty_pay_times
        }
      })
    },
    sumitPay(){
      let _this = this
      let mini_openid = this.$route.params.mini_openid
      let openid = this.$store.state.userinfo.openid
      let amount = this.pickedAmount
      this.$api.post('/tuodan/spraycoin/pay_h5', {
        mini_openid: mini_openid, openid: openid, amount: amount, system: "h5"
      }, res => {
        if(res.code == 200){
          // alert("pay res: " + JSON.stringify(res))
          if (typeof WeixinJSBridge == "undefined") {
            if (document.addEventListener) {
              document.addEventListener('WeixinJSBridgeReady', function () { this.onBridgeReadyPay(res.msg); }, false);
            } else if (document['attachEvent']) {
              document['attachEvent']('WeixinJSBridgeReady', function () { this.onBridgeReadyPay(res.msg); });
              document['attachEvent']('onWeixinJSBridgeReady', function () { this.onBridgeReadyPay(res.msg); });
            }
          } else {
            this.onBridgeReadyPay(res.msg);
          }
        }else{
          Toast("系统错误，请稍后再试～")
        }
      })
    },
    onBridgeReadyPay(config){
      let _this = this
      window.WeixinJSBridge.invoke('getBrandWCPayRequest', {
        "appId": config.appId,  //公众号ID，由商户传入
        "timeStamp": config.timeStamp,     //时间戳，自1970年以来的秒数
        "nonceStr": config.nonceStr,      //随机串
        "package": config.package,
        "signType": config.signType,     //微信签名方式：
        "paySign": config.paySign //微信签名
      },
      function(res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          Toast('充值成功！')
          _this.showPackagePopup = false
          _this.getSprayBalance()
        }else{
          // Toast('支付失败！')
        }
      });
    }

  },
  mounted(){
    this.getSprayBalance()
    // this.wxConfigInit()
  }
}
</script>

<style scoped>
.page{background:#fff;padding:50px 30px;}
.page .balance-header{align-items:center;justify-content:center;}
.page .balance-header .icon-spray{width:50px;height:50px;margin-right:20px;}
.page .balance-header .title{color:#242425;font-size:32px;font-weight:500;}
.page .balance-amount{
  color:#000;font-size:78px;font-weight:600;text-align:center;margin-top:40px;margin-bottom:60px;
}
.page .usage-hint{color:#8E8989;font-size:24px;text-align:center;}
.btn-next{
  width:670px;margin:0px auto;color:#fff;margin-top:120px;font-size:36px;
  text-align:center;height:88px;line-height:88px;border-radius:26px;
  background:linear-gradient(147deg, #E94A60 0%, #FFA55F 100%);
}
.page .free-spray{color:#0B0302;font-size:30px;text-align:center;margin-top:60px;}
.page .free-spray .text{border-bottom:1px solid #0B0302;}

.page .package-popup{width:100%;padding-top:30px;}
.page .package-popup .balance{font-size:32px;color:#000;font-weight:500;}
.page .package-popup .packages{margin-top:40px;flex-wrap:wrap;padding-left:20px;}
.page .package-popup .package{
  background:#F7F7F7;width:215px;height:165px;border-radius:20px;margin-bottom:30px;margin-right:30px;
}
.page .package-popup .package.row-end{margin-right:0px;}
.page .package-popup .package .hint{
  color:#fff;font-size:22px;background:#FF802C;padding:5px 10px;
  border-radius: 15px 0px 14px 0px;
}
.page .package-popup .package .icon-and-amount{
  align-items:center;justify-content:center;margin-top:10px;margin-bottom:5px;
}
.page .package-popup .package .icon-spray{width:41px;height:43px;margin-right:10px;}
.page .package-popup .package .amount{color:#131313;font-size:41px;font-weight:bold;}
.page .package-popup .package .price{color:#AB9E9E;font-size:24px;text-align:center;}

.btn-pay-instant{
  width:604px;margin:0px auto;color:#fff;margin-top:30px;font-size:30px;
  text-align:center;height:88px;line-height:88px;border-radius:26px;
  background:linear-gradient(147deg, #E94A60 0%, #FFA55F 100%);margin-bottom:50px;
}
</style>
